

const OrderProcess = ({ orderDetails, payment, completeOrder }) => {
  return (
    <>
        <section className="order-process-container">
            <div className="flex flex-row gap-8">
                <div className="order-process-content">
                    <div className={orderDetails ? 'process-number' : 'process-number-unfilled'}>1</div>
                    <div className="flex flex-col">
                        <p className={"order-process-title"}>Order Details</p>
                        <p className="order-process-subtitle">Complete details of the request</p>
                    </div>
                    
                </div>
                <div className="order-process-content">
                <div className={payment ? 'process-number' : 'process-number-unfilled'}>2</div>
                    <div className="flex flex-col">
                        <p className="order-process-title">Payment</p>
                        <p className="order-process-subtitle">Complete payment details</p>
                    </div>
                    
                </div>
                <div className="order-process-content">
                <div className={completeOrder ? 'process-number' : 'process-number-unfilled'}>3</div>
                    <div className="flex flex-col">
                        <p className="order-process-title">Complete Order</p>
                        <p className="order-process-subtitle">Revise order summary</p>
                    </div>
                    
                </div>
            </div>
        </section>
    </>
  )
}

export default OrderProcess